/**
 * Prepared mails already baked the chosen inbox's text signature into the body.
 * Footer + SMTP must use that same account on send — not lastUsedSender / Random.
 */

export const pickPreparedSenderAccount = (prepared, accounts = []) => {
  if (!prepared || !Array.isArray(accounts) || accounts.length === 0) return null;
  const id = typeof prepared.senderId === "string" ? prepared.senderId : "";
  if (id) {
    const byId = accounts.find((a) => a && a.id === id);
    if (byId) return byId;
  }
  const email = typeof prepared.senderEmail === "string" ? prepared.senderEmail : "";
  if (email) {
    return accounts.find((a) => a && a.email === email) || null;
  }
  return null;
};

/**
 * Random rotation never wins on a prepared mail (signature vs footer would split).
 * An explicit From pick after the mail is on screen is honored.
 */
export const resolvePreparedSendEmail = ({
  preparedAccount,
  selectedSenderEmail,
  randomSenderMode,
}) => {
  if (!preparedAccount) return selectedSenderEmail || "";
  if (randomSenderMode) return preparedAccount.email;
  return selectedSenderEmail || preparedAccount.email;
};
